export default "__VITE_ASSET__Dp_ct1RG__"